module.exports = __webpack_public_path__ + "static/img/7.07a61a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/vivo/7.png
// module id = 2IQU
// module chunks = 0